import React, {Component} from 'react';
import {TimedBidding} from '@proxibid/proxiponents';
import LegacyEventService from '../shared/legacy-event-service';
import LazyLoad from 'react-lazyload';

class TimedBiddingManager extends Component {

    render() {
        return (
            <LazyLoad height={200} offset={500} once={true}>
                <TimedBidding
                    {...this.props}
                    eventService={LegacyEventService}
                />
            </LazyLoad>
        );
    }
}

export default TimedBiddingManager;